const EUR = (v) => (Number(v) || 0).toLocaleString("pt-PT", { style: "currency", currency: "EUR" });

function Kpi({ label, value, highlight, testid }) {
  const bg = highlight === "accent"
    ? "bg-[#0F1829] text-white border-[#0F1829]"
    : highlight ? "bg-white border-[#0F1829]" : "bg-white border-[#E6E1D6]";
  return (
    <div className={`px-3 py-3 border rounded ${bg}`} data-testid={testid}>
      <div className={`text-[9px] uppercase tracking-[0.15em] font-bold ${highlight === "accent" ? "text-white/60" : "text-[#978D78]"}`}>
        {label}
      </div>
      <div className={`font-mono text-lg mt-0.5 ${highlight === "accent" ? "text-white" : "text-[#0F1829]"}`}>
        {value}
      </div>
    </div>
  );
}

export default function PayoutKpis({ total, sumTotal, onlyAvailable, selectedCount, totalSelected }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-4">
      <Kpi label="Consultores a Pagar" value={total.toLocaleString("pt-PT")} testid="kpi-count" />
      <Kpi label={onlyAvailable ? "Total Disponível" : "Total Por Pagar"} value={EUR(sumTotal)} highlight testid="kpi-sum" />
      <Kpi label="Selecionados" value={selectedCount.toLocaleString("pt-PT")} testid="kpi-selected" />
      <Kpi label="Soma Selecionados" value={EUR(totalSelected)} highlight="accent" testid="kpi-sum-selected" />
    </div>
  );
}
